/* Urban Calm Learning Centre interaction bundle */
(function(){
  'use strict';
  function toast(message){
    var old=document.querySelector('.uc-learn__toast');
    if(old) old.remove();
    var el=document.createElement('div');
    el.className='uc-learn__toast';
    el.setAttribute('role','status');
    el.setAttribute('aria-live','polite');
    el.setAttribute('aria-atomic','true');
    el.textContent=message;
    document.body.appendChild(el);
    window.setTimeout(function(){el.remove();},2400);
  }
  function slugify(value){
    return (value||'urban-calm-mushroom-coffee-guide').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'').slice(0,70)||'urban-calm-mushroom-coffee-guide';
  }
  function wrapText(ctx,text,maxWidth){
    var words=(text||'').trim().split(/\s+/).filter(Boolean),lines=[],line='';
    words.forEach(function(word){
      var test=line?line+' '+word:word;
      if(ctx.measureText(test).width>maxWidth&&line){lines.push(line);line=word}else{line=test}
    });
    if(line)lines.push(line);
    return lines;
  }
  function drawWrapped(ctx,text,x,y,maxWidth,lineHeight,maxLines){
    var lines=wrapText(ctx,text,maxWidth);
    if(maxLines&&lines.length>maxLines){
      lines=lines.slice(0,maxLines);
      var last=lines[lines.length-1];
      while(last.length>1&&ctx.measureText(last+'…').width>maxWidth)last=last.slice(0,-1);
      lines[lines.length-1]=last.replace(/[\s,.!?;:]+$/,'')+'…';
    }
    lines.forEach(function(line,index){ctx.fillText(line,x,y+(index*lineHeight))});
    return y+(lines.length*lineHeight);
  }
  function roundRect(ctx,x,y,w,h,r){
    var radius=Math.min(r,w/2,h/2);
    ctx.beginPath();ctx.moveTo(x+radius,y);ctx.arcTo(x+w,y,x+w,y+h,radius);ctx.arcTo(x+w,y+h,x,y+h,radius);ctx.arcTo(x,y+h,x,y,radius);ctx.arcTo(x,y,x+w,y,radius);ctx.closePath();
  }
  window.UCLearningCentreUtils={toast:toast,slugify:slugify,wrapText:wrapText,drawWrapped:drawWrapped,roundRect:roundRect};
})();

(function(){
  'use strict';
  var U=window.UCLearningCentreUtils;if(!U)return;
  window.UCLearningCentreDrawCard=function(ctx,card,P){
    var left=82,right=998,width=right-left;
    var kicker=(card.querySelector('.uc-learn__guide-topline>span')||{}).textContent||'Mushroom coffee field guide';
    var title=(card.querySelector('h3')||{}).textContent||'Urban Calm Learning Centre';
    var intro=(card.querySelector('.uc-learn__guide-intro')||{}).textContent||'';
    var footer=(card.querySelector('.uc-learn__guide-footer')||{}).textContent||'';
    var factEls=card.querySelectorAll('.uc-learn__facts>div');
    ctx.textBaseline='alphabetic';ctx.fillStyle=P.ink;ctx.font='700 43px Arial, Helvetica, sans-serif';ctx.fillText('URBAN CALM',left,94);
    ctx.fillStyle=P.muted;ctx.font='700 17px Arial, Helvetica, sans-serif';ctx.letterSpacing='2px';ctx.fillText('COFFEE  •  MUSHROOMS  •  ORIGIN',left,126);ctx.letterSpacing='0px';
    ctx.fillStyle=P.accent;ctx.font='700 20px Arial, Helvetica, sans-serif';ctx.fillText(kicker.trim().toUpperCase(),left,204);
    ctx.fillStyle=P.ink;ctx.font='700 66px Arial, Helvetica, sans-serif';var y=U.drawWrapped(ctx,title.trim(),left,282,width,72,3);
    if(intro.trim()){ctx.fillStyle=P.muted;ctx.font='400 27px Arial, Helvetica, sans-serif';y=U.drawWrapped(ctx,intro.trim(),left,y+18,width,38,3)+12}
    var factTop=Math.max(y+24,470),factGap=14,available=1120-factTop,factHeight=Math.min(154,Math.max(128,(available-(factGap*3))/4));
    Array.prototype.slice.call(factEls,0,4).forEach(function(fact,index){
      var fy=factTop+index*(factHeight+factGap);U.roundRect(ctx,left,fy,width,factHeight,20);ctx.fillStyle=P.soft;ctx.fill();ctx.strokeStyle=P.line;ctx.lineWidth=1.5;ctx.stroke();
      var dt=(fact.querySelector('dt')||{}).textContent||'',dd=(fact.querySelector('dd')||{}).textContent||'';
      ctx.fillStyle=P.accent;ctx.font='700 22px Arial, Helvetica, sans-serif';ctx.fillText(dt.trim(),left+26,fy+41);ctx.fillStyle=P.ink;ctx.font='400 23px Arial, Helvetica, sans-serif';U.drawWrapped(ctx,dd.trim(),left+26,fy+78,width-52,31,2);
    });
    if(footer.trim()){ctx.fillStyle=P.muted;ctx.font='400 20px Arial, Helvetica, sans-serif';U.drawWrapped(ctx,footer.trim(),left,1184,width,28,2)}
    ctx.strokeStyle=P.line;ctx.beginPath();ctx.moveTo(left,1260);ctx.lineTo(right,1260);ctx.stroke();ctx.fillStyle=P.ink;ctx.font='700 19px Arial, Helvetica, sans-serif';ctx.fillText('urbancalmcoffee.ca',left,1304);
    ctx.fillStyle=P.muted;ctx.font='400 17px Arial, Helvetica, sans-serif';ctx.textAlign='right';ctx.fillText('Learn more + sources at Urban Calm',right,1304);ctx.textAlign='left';
  };
})();

(function(){
  'use strict';
  var U=window.UCLearningCentreUtils,D=window.UCLearningCentreDrawCard;if(!U||!D)return;
  function makeShareCanvas(card){
    var canvas=document.createElement('canvas');canvas.width=1080;canvas.height=1350;var ctx=canvas.getContext('2d');if(!ctx)return null;
    var isGreen=card.classList.contains('uc-learn__guide-card--green'),isDark=card.classList.contains('uc-learn__guide-card--dark'),isSand=card.classList.contains('uc-learn__guide-card--sand');
    var P={bg:isGreen?'#294A38':isDark?'#1F2420':isSand?'#E9DFCF':'#F7F4EE',ink:(isGreen||isDark)?'#FFFFFF':'#1F211D',muted:(isGreen||isDark)?'rgba(255,255,255,.72)':'#65675F',line:(isGreen||isDark)?'rgba(255,255,255,.18)':'rgba(31,33,29,.16)',accent:(isGreen||isDark)?'#D9E4DC':'#244132',soft:(isGreen||isDark)?'rgba(255,255,255,.055)':'rgba(255,255,255,.54)'};
    ctx.fillStyle=P.bg;ctx.fillRect(0,0,canvas.width,canvas.height);ctx.strokeStyle=(isGreen||isDark)?'rgba(255,255,255,.055)':'rgba(36,65,50,.06)';ctx.lineWidth=2;[180,260,340].forEach(function(r){ctx.beginPath();ctx.arc(1005,85,r,0,Math.PI*2);ctx.stroke()});
    D(ctx,card,P);return canvas;
  }
  window.UCLearningCentreShare={toast:U.toast,slugify:U.slugify,makeShareCanvas:makeShareCanvas};
})();

(function(){
  'use strict';
  var UC=window.UCLearningCentreShare;if(!UC)return;
  function dataUrlToBlob(dataUrl){
    var parts=dataUrl.split(','),mime=(parts[0].match(/:(.*?);/)||[])[1]||'image/png',binary=atob(parts[1]),bytes=new Uint8Array(binary.length);
    for(var i=0;i<binary.length;i++)bytes[i]=binary.charCodeAt(i);
    return new Blob([bytes],{type:mime});
  }
  function saveBlob(blob,fileName){
    var url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download=fileName;document.body.appendChild(a);a.click();a.remove();window.setTimeout(function(){URL.revokeObjectURL(url)},1000);
  }
  function shareCard(button,card){
    var title=(card.getAttribute('data-share-title')||'Urban Calm Learning Centre guide').trim(),original=button.textContent;
    button.setAttribute('aria-busy','true');button.textContent='Creating…';
    try{
      var canvas=UC.makeShareCanvas(card);if(!canvas)throw new Error('Canvas unavailable');
      var blob=dataUrlToBlob(canvas.toDataURL('image/png')),fileName=UC.slugify(title)+'.png',file;
      try{file=new File([blob],fileName,{type:'image/png'})}catch(e){file=null}
      var pageUrl=window.location.href.split('#')[0]+'#mushroom-coffee-field-guide';
      if(file&&navigator.share&&navigator.canShare&&navigator.canShare({files:[file]})){
        navigator.share({title:title,text:title+' — Urban Calm Learning Centre',url:pageUrl,files:[file]}).catch(function(err){if(err&&err.name!=='AbortError'){saveBlob(blob,fileName);UC.toast('Social graphic saved')}});
      }else{saveBlob(blob,fileName);UC.toast('Social graphic saved — ready to post')}
    }catch(err){
      var fallback=window.location.href.split('#')[0]+'#mushroom-coffee-field-guide';
      if(navigator.share){navigator.share({title:title,text:title+' — Urban Calm Learning Centre',url:fallback}).catch(function(){})}
      else if(navigator.clipboard){navigator.clipboard.writeText(fallback).then(function(){UC.toast('Guide link copied')})}
    }finally{button.removeAttribute('aria-busy');button.textContent=original}
  }
  document.addEventListener('click',function(event){var button=event.target.closest('[data-uc-share]');if(!button)return;var card=button.closest('[data-uc-share-card]');if(!card)return;shareCard(button,card)});
})();
